export interface SubscriptionTier {
  id: string;
  name: string;
  price: number; // in cents
  priceDisplay: string;
  interval: 'month' | 'year';
  features: string[];
  description: string;
  popular?: boolean;
  stripeProductId?: string;
  stripePriceId?: string;
}

export const SUBSCRIPTION_TIERS: SubscriptionTier[] = [
  {
    id: 'elite',
    name: 'Elite Access',
    price: 2999, // $29.99 annual
    priceDisplay: '$29.99',
    interval: 'year',
    description: 'Full access to all EightyThreeLabs features',
    popular: true,
    features: [
      'Unlimited access to all mathematical challenges',
      'Advanced progress tracking and analytics',
      'Priority customer support',
      'Early access to new features',
      'Ad-free experience',
      'Export your progress data'
    ],
    stripeProductId: process.env.REACT_APP_STRIPE_PRODUCT_ID,
    stripePriceId: 'price_1S0UpJJHshPgikQWHdLrJoMC', // Hardcoded for testing
  }
];

export const getSubscriptionTier = (tierId: string): SubscriptionTier | undefined => {
  return SUBSCRIPTION_TIERS.find(tier => tier.id === tierId);
};

export const hasLearningAccess = (subscriptionTier?: string): boolean => {
  // Learning not available yet - coming soon
  return false;
};

export const hasGamesAccess = (subscriptionTier?: string): boolean => {
  return subscriptionTier === 'elite';
};

export const isComingSoon = (tierId: string): boolean => {
  // No tiers are coming soon anymore - Premium gets Elite access
  return false;
};

export const getEliteUpgradeCount = async (): Promise<number> => {
  // This would normally check the database for current Premium subscriber count
  // For now, return 0 to show the promotion is active
  return 0;
};

export const isElitePromotionActive = (): boolean => {
  // Promotion is active - first 1000 Premium users get Elite access
  return true;
};